<template>
    <div class="mx-3">
        <Modal
                :text="modalText"
                id="modal_show1"
        />

        <table class="w-full d-none d-md-table">
            <thead class="h-11 bg-lightGray">
            <tr class="font-bold">
                <td class="pl-2">#</td>
                <td class="pl-2">{{ $t('date') }}</td>
                <td class="pl-2">{{ $t('product.count') }}</td>
                <td class="pl-2">{{ $t('inventory.responsiblePerson') }}</td>
                <td class="pl-2">{{ $t('productPriceModify.prognosis') }}</td>
                <td class="pl-2">{{ $t('productPriceModify.difference') }}</td>
                <td class="pl-2">{{ $t('actions') }}</td>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="product of getModifiedProducts"
                :key="product.id"
                class="h-11"
            >
                <td class="pl-2">{{ product.id }}</td>
                <td class="pl-2">{{ dateFormat(product.createdAt) }}</td>
                <td class="pl-2">{{ product.amount }}</td>
                <td class="pl-2">{{ product.person.givenName }} {{ product.person.familyName }}</td>
                <td class="pl-2">
                    <span v-if="product.prognosisRate > 0" class="p-1 mx-1 rounded" :style="`background-color: ${howBgColor(product.prognosisRate > 0)}`">
                        {{ product.prognosisRate }}%
                        <font-awesome-icon
                            class="icon-link-green"
                            :icon="['fa', 'arrow-up']"
                        />
                    </span>
                    <span v-if="100 - product.prognosisRate > 0" class="p-1 mx-1 rounded" :style="`background-color: ${howBgColor(100 - product.prognosisRate < 0)}`">
                        {{ 100 - product.prognosisRate }}%
                        <font-awesome-icon
                            class="icon-link-red"
                            :icon="['fa', 'arrow-down']"
                        />
                    </span>
                </td>
                <td class="pl-2">
                    <span v-if="product.difference > 0" class="p-1 mx-1 rounded" :style="`background-color: ${howBgColor(product.difference > 0)}`">
                        {{ product.difference }}
                        <font-awesome-icon
                            class="icon-link-green"
                            :icon="['fa', 'arrow-up']"
                        />
                    </span>
                    <span v-if="product.amount - product.difference > 0" class="p-1 mx-1 rounded" :style="`background-color: ${howBgColor(product.amount - product.difference < 0)}`">
                        {{ product.amount - product.difference }}
                        <font-awesome-icon
                            class="icon-link-red"
                            :icon="['fa', 'arrow-down']"
                        />
                    </span>
                </td>
                <td class="pl-2">

                    <img src="/images/read-more.png" alt="" class="h-8 cursor-pointer"  @click="showModifiedProduct(product)">

                </td>
            </tr>
            </tbody>
        </table>
        <table class="w-full d-md-none">
            <tbody
                v-for="product of getModifiedProducts"
                :key="product.id"
                style="border-bottom: 5px solid #444444"
            >
                <tr class="h-11">
                    <td class="pl-2 font-weight-bold">#</td>
                    <td>{{ product.id }}</td>
                </tr>
                <tr class="h-11">
                    <td class="pl-2 font-weight-bold">{{ $t('date') }}</td>
                    <td>{{ dateFormat(product.createdAt) }}</td>
                </tr>
                <tr class="h-11">
                    <td class="pl-2 font-weight-bold">{{ $t('product.count') }}</td>
                    <td>{{ product.amount }}</td>
                </tr>
                <tr class="h-11">
                    <td class="pl-2 font-weight-bold">{{ $t('inventory.responsiblePerson') }}</td>
                    <td>{{ product.person.givenName }} {{ product.person.familyName }}</td>
                </tr>
                <tr class="h-11">
                    <td class="pl-2 font-weight-bold">{{ $t('productPriceModify.prognosis') }}</td>
                    <td>
                        <template v-if="product.prognosisRate > 0">
                            {{ product.prognosisRate }}%
                            <font-awesome-icon
                                class="icon-link-green"
                                :icon="['fa', 'arrow-up']"
                            />
                        </template>
                        <template v-if="100 - product.prognosisRate > 0">
                            {{ 100 - product.prognosisRate }}%
                            <font-awesome-icon
                                class="icon-link-red"
                                :icon="['fa', 'arrow-down']"
                            />
                        </template>
                    </td>
                </tr>
                <tr class="h-11">
                    <td class="pl-2 font-weight-bold">{{ $t('productPriceModify.difference') }}</td>
                    <td>
                        <template v-if="product.difference > 0">
                            {{ product.difference }}
                            <font-awesome-icon
                                class="icon-link-green"
                                :icon="['fa', 'arrow-up']"
                            />
                        </template>
                        <template v-if="product.amount - product.difference > 0">
                            {{ product.amount - product.difference }}
                            <font-awesome-icon
                                class="icon-link-red"
                                :icon="['fa', 'arrow-down']"
                            />
                        </template>
                    </td>
                </tr>
                <tr class="h-11">
                    <td class="pl-2 font-weight-bold">{{ $t('actions') }}</td>
                    <td>
                        <img src="/images/read-more.png" alt="" class="h-8 cursor-pointer"  @click="showModifiedProduct(product)">
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import Modal from "@/components/html/Modal.vue";

export default {
    name: "ProductModifyListTable",
    components: {Modal},
    mixins: [dateFormattingMixin, currencyFormatMixin],
    data() {
        return {
            modalText: ''
        }
    },
    computed: {
        ...mapGetters(['getModifiedProducts']),
    },
    methods: {
        ...mapActions(['setModifyProductDetails']),
        showModifiedProduct(modify) {
            this.setModifyProductDetails(modify)
            this.$i18nHelper.toUrl('product-modify/' + modify.id)
        },
        howBgColor(isPositive) {
            return isPositive ? '#D4F8E5' : '#FFCDB8'
        },
    },
}
</script>

<style scoped>

table tbody tr {
    border-bottom: 1px solid #eaeaea;
}

.icon-link-red {
    color: red;
    font-size: 14px;
    position: relative;
    bottom: 3px;
    font-weight: bold;
}

.icon-link-green {
    font-weight: bold;
    color: #04f304;
    font-size: 14px;
    position: relative;
    bottom: 3px;
}

</style>
